import { TagSearchOutlineIcon } from './TagSearchOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 4747C432-2B54-4686-8689-A8B931F417DE
 * name tag-search-outline
 * version: 6.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/tag-search-outline.svg
 * tags
 */
export const TagFindOutlineIcon = TagSearchOutlineIcon;
export default TagFindOutlineIcon